function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24.6724C18.6274 24.6724 24 19.2998 24 12.6724C24 6.04495 18.6274 0.672363 12 0.672363C5.37258 0.672363 0 6.04495 0 12.6724C0 19.2998 5.37258 24.6724 12 24.6724ZM21.9575 13.6007H17.4191C17.0333 15.8689 15.2581 17.6638 13 18.0788V22.623C17.7483 22.1516 21.5195 18.3587 21.9575 13.6007ZM11 22.623V18.0788C8.74191 17.6638 6.96671 15.8689 6.58093 13.6007H2.04252C2.48052 18.3587 6.25172 22.1516 11 22.623ZM21.9433 11.6007H17.3928C16.958 9.40049 15.2103 7.67215 13 7.26593V2.72174C17.7005 3.18843 21.4435 6.91 21.9433 11.6007ZM11 2.72174C6.29949 3.18843 2.5565 6.91 2.05675 11.6007H6.60727C7.04203 9.40051 8.78968 7.67218 11 7.26594V2.72174ZM12 16.1695C13.9315 16.1695 15.4972 14.6038 15.4972 12.6724C15.4972 10.7409 13.9315 9.1752 12 9.1752C10.0686 9.1752 8.50287 10.7409 8.50287 12.6724C8.50287 14.6038 10.0686 16.1695 12 16.1695Z",
  fill: "#8C949C"
});

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.2a767f8d.svg";
export { ForwardRef as ReactComponent };